<template>
  <div class="main-layout">
    <el-card class="box-outter">
      <c-title slot="header" title="学年学期管理" :back="false"></c-title>
      <el-card class="box-table box-inner" shadow="never">
        <div slot="header" class="btn-group">
          <div class="btn-left">
            <div class="opt-btn" title="新增" @click="goto('')">
              <i class="iconfont icon-add"></i>
            </div>
          </div>
          <!-- 右侧操作按钮 -->
          <table-btns
            :tableColumns="tableColumns"
            @tableColumnsChange="tableColumnsChange"
            @refresh="pageGet(true)"
          ></table-btns>
        </div>

        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          @edit="goto"
          @delete="pageDel"
          @semesterSetting="setCurrent"
          v-loading="pageLoading"
        >
          <template slot="status" slot-scope="scope">
            <span>
              {{
                scope.row.isCurrent == 0
                  ? "否"
                  : scope.row.isCurrent == 1
                  ? "是"
                  : ""
              }}
            </span>
          </template>
          <template slot="custom" slot-scope="scope">
            <div class="contr-btn-group">
              <div
                v-if="scope.row.isCurrent != 1"
                class="contr-btn"
                title="设置为当前学年学期"
                @click="setCurrent(scope.row.id)"
              >
                <i class="iconfont icon-setting"></i>
              </div>
              <div class="contr-btn" title="编辑" @click="goto(scope.row)">
                <i class="iconfont icon-edit"></i>
              </div>
              <div
                class="contr-btn"
                title="删除"
                @click="pageDel(scope.row.id)"
              >
                <i class="iconfont icon-shanchu"></i>
              </div>
            </div>
          </template>
        </c-table>
      </el-card>
    </el-card>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      :before-close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            :formItems="formItems"
            @submit="submit"
            @resetFields="resetFields"
            labelWidth="150px"
          >
          </c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/index";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/account/sys/year/semester/listPage",
  pageDelPath: "/account/sys/year/semester",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/account/sys/year/semester",
  handleInsertPath: "/account/sys/year/semester/save",
  handleUpdatePath: "/account/sys/year/semester/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  data() {
    let { tableColumns, formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      tableColumns,
      dialogFormVisible: false,
      title: "",
      parentId: "",
      options: [],
      tableData: [],
      defaultHandleData: {
        year: "",
        semester: "",
        startDate: "",
        endDate: "",
        startWeek: "",
        endWeek: "",
        isCurrent: "",
        remark: "",
        yearSemesterNo: "",
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  mounted() {},
  methods: {
    goto(data) {
      let id = data.id;
      this.handleData = Object.assign({}, this.defaultHandleData);
      this.dialogFormVisible = true;
      if (id) {
        this.title = "编辑";
        this.handleData = Object.assign({}, data);
      } else {
        this.title = "新增";
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.idList = [];
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    handleDialogClose(done) {
      this.$refs.cForm.resetFields();
      done();
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleBeforeFn(data) {
      data.yearSemesterNo =
        data.year + "-" + (Number(data.year) + 1) + "-" + data.semester;
      return data;
    },
    handleAfterFn() {
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    setCurrent(id) {
      this.$confirm("此操作将设置该学期为当前学年学期, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$http
          .post("/account/sys/year/semester/setCurrent", id)
          .then((res) => {
            if (res.code == this.SUCCESS_CODE) {
              this.refresh();
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error("操作失败，" + err);
          });
      });
    },
  },
};
</script>

